import { Button, TextField } from "@aws-amplify/ui-react";
import { useForm } from "react-hook-form";
import AuthFormShell from "./AuthFormShell";

interface ForgotPasswordFormValues {
  email: string;
}

interface ForgotPasswordFormProps {
  onSubmit: (email: string) => void;
  onBack: () => void;
  onDismissError?: () => void;
  error?: string | null;
  isLoading?: boolean;
}

const ForgotPasswordForm = ({ onSubmit, onBack, onDismissError, error, isLoading }: ForgotPasswordFormProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordFormValues>({ mode: "onSubmit" });

  return (
    <AuthFormShell
      heading="Reset your password"
      onSubmit={handleSubmit((data) => onSubmit(data.email.trim()))}
      error={error}
      onDismissError={onDismissError}
      fields={
        <TextField
          label="Email"
          placeholder="Enter your Email"
          type="email"
          autoComplete="username"
          {...register("email", { required: "Email is required" })}
          hasError={!!errors.email}
          errorMessage={errors.email?.message}
        />
      }
      actions={
        <>
          <Button type="submit" variation="primary" isFullWidth isLoading={isLoading}>
            Reset Password
          </Button>
          <Button type="button" variation="link" onClick={onBack} className="amplify-button--link">
            Back to Sign In
          </Button>
        </>
      }
    />
  );
};

export default ForgotPasswordForm;
